module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"bo-mo-pg-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"document pageContainer \" style=\"display:none;\">\r\n    <div class=\"document-heading page\">\r\n        <i class=\"fa pf-drag draggable notDraggablePage\" draggable=\"true\"></i>\r\n        <h4 class=\"document-title tn-target\" id=\"bo-mo-pgref-")
    ; __append( seq )
    ; __append("\" data-page=\"")
    ; __append(escapeFn( id ))
    ; __append("\" style=\"margin-left:0px;width:85%; text-overflow: ellipsis;\" title=\"")
    ; __append(escapeFn( pageTitle))
    ; __append("\">\r\n            <a role=\"button\">")
    ; __append(escapeFn( pageTitle ))
    ; __append("</a></h4>\r\n\r\n        <a role=\"button\" data-toggle=\"collapse\" data-target=\"#bo-mo-well")
    ; __append(escapeFn( id))
    ; __append("\" class=\"switch\"><i class=\"fa pf-carot-left\"></i></a>\r\n    </div>\r\n    <div id=\"bo-mo-well")
    ; __append(escapeFn( id))
    ; __append("\" class=\"document-body collapse\">\r\n        <div class=\"document-items\">\r\n            <div id=\"behaviors-only-page-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"bo-body objects\">\r\n                <ul class=\"\">\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}